export default "__VITE_ASSET__wyrhnz7i__"